import React from 'react';
import { localise } from '../../../../services/lang/lang';
import StandardModal from '../../Modal/StandardModal';
import EditContactWrapper from './EditContactWrapper';
import { useUnsavedChanges } from '../../UnsavedChanges/UnsavedChangesProvider';
import { useInspectionDetailContext } from '../../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
const EditContactModal = ({ contact, onEditContact, canEdit, onClose, ...rest }) => {
    const { attemptNavigate } = useUnsavedChanges();
    const { isShare } = useInspectionDetailContext();
    return (React.createElement(StandardModal, { "data-testid": "edit_contact_modal", variant: "primary", title: canEdit ? localise('EDIT_CONTACT') : localise('VIEW_CONTACT'), onClose: () => attemptNavigate(onClose), ...rest },
        React.createElement(EditContactWrapper, { variant: "edit", contact: contact, isShare: isShare, onEditContact: onEditContact, canEdit: canEdit })));
};
export default EditContactModal;
